dmx.Formatters('undefined', {

    // default(value):Any
    default: function(o, value) {
        return value;
    }

});
